/*
 *   Copyright (c) 2021 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import React from "react";
import * as Icon from "react-feather";

const navigationConfig = [
  {
    id: "home",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20} />,
    navLink: "/",
  },

  {
    id: "urlList",
    title: "Url",
    type: "item",
    icon: (
      <i
        className="fa fa-random"
        style={{ fontSize: "21px", marginRight: "16px" }}
      ></i>
    ),
    navLink: "/url/list",
  },

  {
    id: "Groups",
    title: "Groups",
    type: "item",
    icon: (
      <i
        className="fa fa-users"
        style={{ fontSize: "21px", marginRight: "14px" }}
      ></i>
    ),
    navLink: "/group/list",
  },
  {
    id: "whatsapp",
    title: "Whatsapp",
    type: "item",
    icon: (
      <i
        className="fa fa-whatsapp"
        style={{ fontSize: "21px", marginRight: "16px" }}
      ></i>
    ),
    navLink: "/whatsapp/getGroupList",
  },
  {
    id: "teams",
    title: "Microsoft Teams",
    type: "item",
    icon: (
      <i
        className="fa fa-windows"
        style={{ fontSize: "21px", marginRight: "16px" }}
      ></i>
    ),
    navLink: "/microsoft_teams/list",
  },
  {
    id: "Staff",
    title: "Staff",
    type: "item",
    icon: (
      <i
        className="fa fa-user"
        style={{ fontSize: "21px", marginRight: "20px" }}
      ></i>
    ),
    navLink: "/staff/list",
  },
  {
    id: "balance",
    title: "Balance Url",
    type: "item",
    icon: (
      <i
        className="fa fa-random"
        style={{ fontSize: "21px", marginRight: "16px" }}
      ></i>
    ),
    navLink: "/balanceCheck/list",
  },
  {
    id: "balance-vendor",
    title: "Balance Vendor",
    type: "item",
    icon: <Icon.ShoppingCart size={20} />,
    navLink: "/balanceVendor/list",
  },

  {
    id: "domain",
    title: "Domain",
    type: "item",
    icon: <Icon.Package size={20} />,
    navLink: "/domain/list",
  },

  // {
  //   id: "logout",
  //   title: "Log Out",
  //   type: "item",
  //   icon: <Icon.LogOut size={20} />,
  //   navLink: "/logout",
  // },
];

export default navigationConfig;
